(() => {
  if (window.__TMP_2PLUS1_DYNAMIC_CTA__) return;
  window.__TMP_2PLUS1_DYNAMIC_CTA__ = true;

  const ROOT_SELECTOR = '[data-tmp-bundle-root]';
  const LOADING_RE = /LOADING|ADDING|ADDED TO CART/i;

  const getState = (root) => ({
    hasSecond: Boolean(root.querySelector('[data-progress-second].is-done')),
    hasFree: Boolean(root.querySelector('[data-progress-free].is-done'))
  });

  const syncCards = (root) => {
    root.querySelectorAll('.tmp-meller-card__choose').forEach((button) => {
      const selected = button.closest('.tmp-meller-card')?.classList.contains('is-selected');
      const label = selected ? 'ADDED ✓' : 'CHOOSE';
      if (button.textContent !== label) button.textContent = label;
    });
  };

  const syncCta = (root) => {
    const cta = root.querySelector('[data-bundle-cta]');
    if (!cta || cta.classList.contains('is-loading') || LOADING_RE.test(cta.textContent || '')) return;

    const { hasSecond, hasFree } = getState(root);
    const label = !hasSecond
      ? 'CHOOSE SECOND PAIR'
      : !hasFree
        ? 'CHOOSE YOUR FREE PAIR'
        : 'ADD ALL 3 TO CART';

    if (cta.textContent !== label) cta.textContent = label;
    cta.classList.toggle('is-ready', hasSecond && hasFree);
    cta.setAttribute('aria-label', label);
  };

  const sync = (root) => {
    syncCards(root);
    syncCta(root);
  };

  const guideToSelector = (root) => {
    const rail = root.querySelector('[data-product-rail]');
    (rail || root).scrollIntoView({ behavior: 'smooth', block: 'center' });
    root.classList.add('tmp-bundle-attention');
    window.setTimeout(() => root.classList.remove('tmp-bundle-attention'), 700);
  };

  const mount = (root) => {
    if (!root || root.dataset.tmpDynamicCtaReady === 'true') return;
    root.dataset.tmpDynamicCtaReady = 'true';

    let queued = false;
    const queueSync = () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        sync(root);
      });
    };

    root.addEventListener('click', (event) => {
      const cta = event.target.closest?.('[data-bundle-cta]');
      if (!cta || !root.contains(cta)) return;

      const { hasSecond, hasFree } = getState(root);
      if (hasSecond && hasFree) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      guideToSelector(root);
    }, true);

    new MutationObserver(queueSync).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });

    ['tmp:second_pair_selected', 'tmp:free_pair_selected'].forEach((name) => {
      root.addEventListener(name, queueSync);
    });

    sync(root);
  };

  const scan = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) mount(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(mount);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
